import {
  Component,
  Input,
  Output,
  EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy
} from '@angular/core';
import {Reminder} from '../../../models/reminder.model';
import {ReminderSettings} from '../../../../site-preferences/models/reminder-settings.model';

require('./document-edit.scss');
@Component({
  standalone: false,
  selector: 'app-document-edit',
  templateUrl: './document-edit.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentEditComponent {
  @Input() document: Reminder;
  @Input() documentSettings: ReminderSettings;
  @Input() isLoading: boolean;
  @Input() permissionUpdate: string;
  @Input() permissionDelete: string;
  @Input() isSelected: boolean;
  @Input() pattern: string;

  @Output() onUpload = new EventEmitter<{ files: any, documentSettingsId: string }>();
  @Output() onUpdate = new EventEmitter<{ files: any, documentSettingsId: string }>();
  @Output() onDeleted = new EventEmitter<any>();
  @Output() onSelect = new EventEmitter<any>();


  uploadDocument(files: any): void {
    this.onUpload.emit({files: files, documentSettingsId: this.documentSettings.id});
  }

  updateDocument(files: any): void {
    this.onUpdate.emit({files: files, documentSettingsId: this.documentSettings.id});
  }
}
